<template>
  <div class="AndroidImportSuccess">
    <img :src="require('@/assets/images/success.svg')" />
    <h2>Import zakończono sukcesem</h2>
    <span>Możesz wyjść z tego okna</span>
  </div>
</template>

<script>
export default {
  name: "AndroidImportSuccess"
}
</script>

<style lang="scss" scoped>
.AndroidImportSuccess {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000;
  z-index: 99;
  text-align: center;
  img {
    margin-top: 12rem;
    width: 64px;
  }
  span {
    color: #999;
  }
}
</style>